<ng-container [ngSwitch]="this.menuSelect">
  <ng-container *ngSwitchCase="'accountMenuModal'">
    <div class="tabs-title">
      <div
        *ngFor="let item of this.accountTabMenuRebuild(this.accountTabMenu)"
        class="tabs-title-row"
        [ngClass]="{ active: this.UiHelper.tabSelected == item.tabId }"
        (click)="this.UiHelper.tabsTitleChange(item.tabId)">
        <div class="left-svg">
          <image-loader-utils [url]="item.icon" [extraClasses]="item.iconClass"></image-loader-utils>
        </div>
        <div class="mid">{{ item.title }}</div>
      </div>
      <div class="tabs-down-row">
        <div class="btn colored blue btn-credit">
          <div class="login-button-text logout" (click)="SignOutDialogOpener(true)">
            <image-loader-utils url="logout" extraClasses="logout-icon"></image-loader-utils>
            <span>
              {{ 'logout' | translate }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
  <ng-container *ngSwitchCase="'rightMenu'">
    <div *ngFor="let item of this.accountTabMenuRebuild(this.accountTabMenu, true)" class="mid-container-row" (click)="routeTo(item.route)">
      <ng-container [ngSwitch]="['p1003'] | getProductName">
        <ng-container *ngSwitchCase="'p1003'">
          <div class="left-svg">
            <image-loader-utils url="bullet" extraClasses="bullet"></image-loader-utils>
          </div>
        </ng-container>
        <ng-container *ngSwitchDefault>
          <div class="left-svg">
            <image-loader-utils [url]="item.icon" [extraClasses]="item.iconClass"></image-loader-utils>
          </div>
        </ng-container>
      </ng-container>

      <div class="mid">{{ item.title }}</div>
      <div class="right"></div>
    </div>
  </ng-container>
  <ng-container *ngSwitchCase="'modalMobil'">
    <div class="account-mobile-horizontal-menu">
      <div
        *ngFor="let item of this.accountTabMenuRebuild(this.accountTabMenu)"
        class="h-menu-item"
        [ngClass]="{ active: this.UiHelper.accountMobileMenu == item.tabId }"
        (click)="routeTo(item.route)">
        {{ item.title }}
      </div>
    </div>
  </ng-container>
</ng-container>
